import React from 'react'
import EventBody from '../../../components/AdminDashboard/Events/EventBody'
import SideNav from '../../../layouts/AdminDashboard/SideNav'

const Event = () => {
  return (
    <div className='flex justify-end mobile:justify-start mobile:w-screen mobile:flex-col min-h-screen w-full mobile:bg-[#E5E5E5]'>

        {/* Side nav */}
        <SideNav />

        {/* Body section */}
        <EventBody />
    </div>
  )
}

export default Event